module.exports = __webpack_public_path__ + "static/media/smallPhone.71b3e850.png";